
































































import Vue from 'vue'
import Component from 'vue-class-component'
import { ELetterStatus, EUserPermissions, ILetter } from '@zunta/configurations'
import TrackingMail from '@/components/TrackingMail.vue'
import ResidentLabel from '@/components/labels/ResidentLabel.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Icon from '@/components/Icon.vue'
import { LETTERS_MAILED_STATUSES, LETTERS_STATUSES_LABEL_MAP, LETTERS_UNMAILED_STATUSES } from '@/constants'
import { getModule } from 'vuex-module-decorators'
import { User } from '@/classes/User'
import Api from '@/api'
import FacilityLabel from '@/components/labels/FacilityLabel.vue'
import { ETableColumnType } from '@/interfaces'
import { LettersModule } from '@/store/modules/letters.module'
import Table from '@/components/tables/Table.vue'
import StatusLetter from '@/components/statuses/StatusLetter.vue'

@Component({
  components: {
    StatusLetter,
    Table,
    FacilityLabel,
    Icon,
    DateTimeLabel,
    ResidentLabel,
    TrackingMail
  }
})
export default class LettersList extends Vue {
  letterModuleInstance: LettersModule = getModule(LettersModule, this.$store)
  ELetterStatus: any = ELetterStatus

  mounted () {
    this.fetchLetters({})
  }

  user: User = Api.getUser() as User

  trackingLetter: ILetter | null = null

  showTracking: boolean = false

  get config () {
    const config = {
      clearFilterBtn: {
        wrapperClass: 'position-absolute',
        wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
        class: 'rounded-bottom'
      },
      useQuery: true,
      usePagination: true,
      fetchFunction: this.fetchLetters,
      rowClick: this.goLetterReview,
      columns: [
        {
          minWidth: '150px',
          width: 20,
          key: 'facility',
          searchKey: 'facilityName',
          label: 'Facility',
          hasSearch: true,
          type: ETableColumnType.default
        },
        {
          minWidth: '150px',
          width: 20,
          key: 'resident',
          searchKey: 'resident',
          label: 'Resident',
          hasSearch: true,
          type: ETableColumnType.default
        },
        {
          minWidth: '150px',
          width: 20,
          key: 'status',
          searchKey: 'status',
          label: 'Status',
          hasSearch: true,
          type: ETableColumnType.select,
          options: this.statusesFilters
        },
        {
          minWidth: '150px',
          width: 20,
          key: 'template',
          searchKey: 'template',
          label: 'Template',
          hasSearch: true,
          type: ETableColumnType.default
        },
        {
          minWidth: '150px',
          width: 20,
          key: 'lastUpdate',
          searchKey: 'lastUpdate',
          label: 'Last Updated',
          hasSearch: true,
          type: ETableColumnType.date
        }
      ]
    }

    if (!this.isUnmailed) {
      // @ts-ignore
      config.columns.push({ minWidth: '30px', width: 5, key: 'actions' })
    }
    return config
  }

  get letterListTotal () {
    return this.letterModuleInstance.letterTotal
  }

  get letterList () {
    return this.letterModuleInstance.letterList
  }

  get lettersType () {
    return this.isUnmailed ? 'unmailed' : 'mailed'
  }

  get statusesFilters () {
    return this.lettersType === 'mailed' ? this.mailingStatusesFilter : this.unmailedStatusesFilter
  }

  get unmailedStatusesFilter () {
    return LETTERS_UNMAILED_STATUSES.map(status => {
      return {
        content: LETTERS_STATUSES_LABEL_MAP[status],
        key: status,
        value: status
      }
    })
  }

  get mailingStatusesFilter () {
    return [{
      content: LETTERS_STATUSES_LABEL_MAP[ELetterStatus.DELIVERED],
      key: ELetterStatus.DELIVERED,
      value: ELetterStatus.DELIVERED
    }, {
      content: LETTERS_STATUSES_LABEL_MAP[ELetterStatus.REROUTED],
      key: ELetterStatus.REROUTED,
      value: ELetterStatus.REROUTED
    }, {
      content: LETTERS_STATUSES_LABEL_MAP[ELetterStatus.IN_TRANSIT],
      key: ELetterStatus.IN_TRANSIT,
      value: ELetterStatus.IN_TRANSIT
    }, {
      content: LETTERS_STATUSES_LABEL_MAP[ELetterStatus.IN_LOCALAREA],
      key: ELetterStatus.IN_LOCALAREA,
      value: ELetterStatus.IN_LOCALAREA
    }, {
      content: LETTERS_STATUSES_LABEL_MAP[ELetterStatus.IN_PROCESS],
      key: ELetterStatus.IN_PROCESS,
      value: ELetterStatus.IN_PROCESS
    }, {
      content: LETTERS_STATUSES_LABEL_MAP[ELetterStatus.PRINTED_LOCALLY],
      key: ELetterStatus.PRINTED_LOCALLY,
      value: ELetterStatus.PRINTED_LOCALLY
    }, {
      content: LETTERS_STATUSES_LABEL_MAP[ELetterStatus.PROCESSED_FOR_DELIVERY],
      key: ELetterStatus.PROCESSED_FOR_DELIVERY,
      value: ELetterStatus.PROCESSED_FOR_DELIVERY
    }, {
      content: LETTERS_STATUSES_LABEL_MAP[ELetterStatus.EMAILED],
      key: ELetterStatus.EMAILED,
      value: ELetterStatus.EMAILED
    }]
  }

  get isUnmailed () {
    return this.$route.name === 'management-mailings-letters-batch-unmailed'
  }

  get batchID () {
    return this.$route.params.id
  }

  openTracker (letter: ILetter) {
    this.trackingLetter = letter
    this.showTracking = true
  }

  async fetchLetters (filters: any) {
    await this.letterModuleInstance.fetchBatchLettersByFilters({
      filters: {
        ...filters,
        mailed: this.lettersType
      },
      batchId: this.batchID
    })
  }

  goLetterReview (letter: ILetter) {
    if (!this.user.hasPermissionFor(EUserPermissions.REVIEW_STATEMENTS)) {
      return
    }

    this.$locationManager.rememberLocation(this.$route.fullPath)

    if (LETTERS_MAILED_STATUSES.indexOf(letter.status) !== -1) {
      this.$router.push({
        name: 'review-letters',
        params: {
          batch: this.batchID,
          type: 'mailed',
          letter: letter.id.toString()
        }
      })
      return
    }

    this.$router.push({
      name: 'review-letters',
      params: {
        batch: this.batchID,
        type: 'unmailed',
        letter: letter.id.toString()
      },
      query: {
        defaultType: 'ALL'
      }
    })
  }
}
